import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store'
import routes from '../../routes/routes'
import downloadService from '../../services/download.service'
import alertService from '../../services/alert.service'
import packTraceBundleApi from '../../apis/packTraceBundle.api'
import { replacePage, replaceLimit, replaceSearch } from './PackTraces.slice'
import { paginate } from './PackTraces.thunk'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'
import HeadingRow from '../../components/HeadingRow'
import RangeExport from '../../components/RangeExport'
import { i18n } from "../../i18n/i18n";

interface PackTracesProps extends RouteComponentProps,
  ConnectedProps<typeof connector> {}

class PackTraces extends Component<PackTracesProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Code"), path: 'code' },
    { heading: i18n("Work order"), path: 'workOrder.code' },
    { heading: i18n("Line number"), path: 'lineNumber' },
    { heading: i18n("LPNs"), path: 'licensePlates', breakable: true },
    { heading: i18n("Created at"),
      path: 'createdAt',
      date: true,
      tooltip: ['createdUser.username']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: PackTracesProps) {
    super(props)
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
  }

  handleExportClick (startAt: string, endAt: string) {
    const params = { startAt, endAt }
    packTraceBundleApi.exportReport(params, packTraces => {
      if (!packTraces) {
        alertService.info('No results to export')
        return
      }
      downloadService.packTraces(packTraces)
    })
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'view') {
      const pathname = routes.packTrace
      const state = { id }
      this.props.history.push({ pathname, state })
    }
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Pack Traces")}
              doc='pack-traces'>
              <RangeExport onExport={this.handleExportClick} />
            </HeadingRow>
            <DataTable
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.packTraces
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(PackTraces))
